import React from 'react'

const BookingView = () => {
  return (
    <div>BookingView</div>
  )
}

export default BookingView